import {call, put, takeLatest} from 'redux-saga/effects';
import {
    PROGRAM_METADATA_QUERY_START,
    ProgramMetadataQueryStartAction,
    getProgramMetadataQuerySuccessAction,
    getProgramMetadataQueryFailedAction
} from "../actions/ProgramMetadataAction";
import ApiUtil from "src/utils/ApiUtil";
import {ProgramMetadata} from "src/model/ProgramMetadata";
import MetricsUtil from "src/utils/MetricsUtil";


export function* getProgramMetadata(action: ProgramMetadataQueryStartAction) {
    try {
        let parameters: any = {countryCode: action.countryCode, asin: action.asin};
        // @ts-ignore
        const response = yield call(ApiUtil.callApiWithTimeout, "getprograms", parameters);

        let metricsUtil = MetricsUtil.getMetricsUtil();
        let programMetadataArray: Array<ProgramMetadata> = response.programInfoList;
        programMetadataArray.map((programMetadata, index) => {
            let programName = programMetadata.name;
            if (metricsUtil && programName != 'MFN' && programName != 'Core') {
                metricsUtil.publishCounter(programName, "ProgramEligibility");
            }
        });

        yield put(getProgramMetadataQuerySuccessAction(response));
    } catch (error) {
        console.error("Call API getprograms error" + error)
        yield put(getProgramMetadataQueryFailedAction());
        return;
    }


}

export default function* programMetadata() {
    yield takeLatest(PROGRAM_METADATA_QUERY_START, getProgramMetadata);
}
